<template>
  <v-container fluid>
    <h2 class="text-center mb-5">Mantenimiento Evaluaciones de Desempeño</h2>

    <v-row>
      <!-- GRUPOS -->
      <v-col cols="12" md="4">
        <v-card outlined>
          <v-card-title class="justify-space-between">
            <div class="text-h6">Grupos</div>
            <div>
              <v-select
                :items="tipos"
                v-model="filtros.tipo"
                label="Tipo"
                dense hide-details class="mr-3"
                style="max-width:120px"
                @change="loadGrupos"
              />
              <v-btn small color="primary" @click="openGrupoDialog()">Nuevo</v-btn>
            </div>
          </v-card-title>

          <v-data-table
            :headers="headersGrupos"
            :items="grupos"
            item-key="GrupoPreguntaValoracionId"
            dense
            :loading="loadingGrupos"
            @click:row="selectGrupo"
            class="elevation-1"
          >
            <template v-slot:item.Activa="{ item }">
              <v-chip x-small :color="item.Activa ? 'green' : 'grey'" dark>
                {{ item.Activa ? 'Activa' : 'Inactiva' }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn icon x-small @click.stop="toggleGrupo(item)" :title="item.Activa ? 'Desactivar' : 'Activar'">
                <v-icon>{{ item.Activa ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off' }}</v-icon>
              </v-btn>
              <v-btn icon x-small @click.stop="openGrupoDialog(item)" title="Editar">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon x-small @click.stop="deleteGrupo(item)" title="Eliminar">
                <v-icon color="red">mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <!-- PREGUNTAS -->
      <v-col cols="12" md="8">
        <v-card outlined>
          <v-card-title class="justify-space-between">
            <div class="text-h6">
              Preguntas
              <span v-if="grupoSel">— {{ grupoSel.Nombre }} ({{ grupoSel.TipoValoracion }})</span>
            </div>
            <div>
              <v-text-field
                v-model="filtros.buscar"
                prepend-inner-icon="mdi-magnify"
                dense hide-details
                label="Buscar pregunta"
                style="max-width:220px"
                class="mr-3"
              />
              <v-btn small color="primary" :disabled="!grupoSel" @click="openPreguntaDialog()">Nueva</v-btn>
            </div>
          </v-card-title>

          <v-data-table
            :headers="headersPreguntas"
            :items="preguntasFiltradas"
            item-key="PreguntaValoracionId"
            dense
            :loading="loadingPreguntas"
            class="elevation-1"
          >
            <template v-slot:item.Activa="{ item }">
              <v-chip x-small :color="item.Activa ? 'green' : 'grey'" dark>
                {{ item.Activa ? 'Activa' : 'Inactiva' }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn icon x-small @click.stop="togglePregunta(item)" :title="item.Activa ? 'Desactivar' : 'Activar'">
                <v-icon>{{ item.Activa ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off' }}</v-icon>
              </v-btn>
              <v-btn icon x-small @click.stop="openPreguntaDialog(item)" title="Editar">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon x-small @click.stop="deletePregunta(item)" title="Eliminar">
                <v-icon color="red">mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- DIALOGO GRUPO -->
    <v-dialog v-model="dlgGrupo.visible" max-width="520px">
      <v-card>
        <v-card-title class="text-h6">{{ dlgGrupo.editing ? 'Editar grupo' : 'Nuevo grupo' }}</v-card-title>
        <v-card-text>
          <v-text-field v-model="dlgGrupo.data.Nombre" label="Nombre" outlined dense/>
          <v-text-field v-model="dlgGrupo.data.Descripcion" label="Descripción" outlined dense/>
          <!-- <v-select :items="tipos" v-model="dlgGrupo.data.TipoValoracion" label="Tipo" outlined dense/> -->
          <v-text-field v-model.number="dlgGrupo.data.Orden" label="Orden" type="number" min="1" outlined dense/>
          <v-switch v-model="dlgGrupo.data.Activa" label="Activo"></v-switch>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="dlgGrupo.visible=false">Cancelar</v-btn>
          <v-btn color="primary" @click="saveGrupo">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOGO PREGUNTA -->
    <v-dialog v-model="dlgPregunta.visible" max-width="720px">
      <v-card>
        <v-card-title class="text-h6">{{ dlgPregunta.editing ? 'Editar pregunta' : 'Nueva pregunta' }}</v-card-title>
        <v-card-text>
          <v-textarea v-model="dlgPregunta.data.Texto" label="Texto de la pregunta" outlined dense/>
          <v-text-field v-model.number="dlgPregunta.data.Orden" label="Orden" type="number" min="1" outlined dense/>
          <v-switch v-model="dlgPregunta.data.Activa" label="Activa"></v-switch>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="dlgPregunta.visible=false">Cancelar</v-btn>
          <v-btn color="primary" :disabled="!grupoSel" @click="savePregunta">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snack.visible" :color="snack.color" top timeout="2500">
      {{ snack.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'AdminValoraciones',
  computed: {
    ...mapState(['urlRaiz', 'empId']),
    preguntasFiltradas() {
      if (!this.filtros.buscar) return this.preguntas;
      const t = this.filtros.buscar.toLowerCase();
      return this.preguntas.filter(p => (p.Texto || '').toLowerCase().includes(t));
    }
  },


data() {
  return {
    tipos: ['AV','RT','TR', 'TM', 'ATR'],
    filtros: { tipo: 'AV', buscar: '' },

    // tablas
    headersGrupos: [
      { text: 'Orden', value: 'Orden', width: 100 },
      { text: 'Nombre', value: 'Nombre' },
      { text: 'Activo', value: 'Activa', width: 100 },
      { text: '', value: 'actions', width: 110, sortable: false }
    ],
    headersPreguntas: [
      { text: 'Orden', value: 'Orden', width: 100 },
      { text: 'Descripción', value: 'Texto' },
      { text: 'Activa', value: 'Activa', width: 80 },
      { text: '', value: 'actions', width: 110, sortable: false }
    ],

    grupos: [],
    preguntas: [],
    grupoSel: null,

    // estados
    loadingGrupos: false,
    loadingPreguntas: false,

    // diálogos
    dlgGrupo: { visible: false, editing: false, data: { Nombre:'', Descripcion:'', TipoValoracion:'AV', Orden:1, Activa:true, EmpId: null } },
    dlgPregunta: { visible: false, editing: false, data: { Texto:'', TipoValoracion:'AV', Orden:1, Activa:true } },

    snack: { visible: false, color: '', text: '' }
  };
},

mounted() {
  this.loadGrupos();
},

methods: {
  toast(text, type='success'){ this.snack.text=text; this.snack.color=type==='error'?'red darken-2':'green darken-2'; this.snack.visible=true; },
  auth() { return { Authorization: localStorage.getItem('token') }; },

  // argar grupos filtrando por empId
  loadGrupos() {
    this.loadingGrupos = true;
    axios.get(`${this.urlRaiz}/api/grupo-pv/list`, { params: { tipo: this.filtros.tipo, empId: this.empId }, headers: this.auth() })
      .then(r => {
        this.grupos = r.data;
        // seleccionar primero si no hay selección
        if (!this.grupoSel && this.grupos.length) {
          this.selectGrupo(this.grupos[0]);
        } else if (this.grupoSel) {
          // refrescar selección
          const found = this.grupos.find(g => g.GrupoPreguntaValoracionId === this.grupoSel.GrupoPreguntaValoracionId);
          if (!found && this.grupos.length) this.selectGrupo(this.grupos[0]);
          else this.selectGrupo(found);
        }
      })
      .catch(()=> this.toast('Error cargando grupos','error'))
      .finally(()=> this.loadingGrupos=false);
  },

  selectGrupo(item) {
    if (!item) { this.grupoSel=null; this.preguntas=[]; return; }
    this.grupoSel = item;
    this.loadPreguntas();
  },

  openGrupoDialog(item) {
    this.dlgGrupo.editing = !!item;
    this.dlgGrupo.data = item 
      ? { ...item } 
      : { 
          Nombre:'', 
          Descripcion:'', 
          TipoValoracion:this.filtros.tipo, 
          Orden: (this.grupos.length+1), 
          Activa:true,
          EmpId: this.empId // <-- asignamos empId al crear
        };
    this.dlgGrupo.visible = true;
  },

  saveGrupo() {
    // siempre enviamos empId para el backend
    if (!this.dlgGrupo.data.EmpId) this.dlgGrupo.data.EmpId = this.empId;

    const url = this.dlgGrupo.editing ? '/api/grupo-pv/update' : '/api/grupo-pv/create';
    axios.post(this.urlRaiz + url, this.dlgGrupo.data, { headers: this.auth() })
      .then(()=>{
        this.dlgGrupo.visible=false;
        this.loadGrupos();
        this.toast('Grupo guardado');
      })
      .catch(()=> this.toast('Error guardando grupo','error'));
  },

  toggleGrupo(item) {
    axios.post(`${this.urlRaiz}/api/grupo-pv/toggle`, { GrupoPreguntaValoracionId: item.GrupoPreguntaValoracionId }, { headers: this.auth() })
      .then(()=> this.loadGrupos())
      .catch(()=> this.toast('Error al cambiar estado','error'));
  },

  deleteGrupo(item) {
    if (!confirm('¿Eliminar grupo? Debe estar sin preguntas.')) return;
    axios.post(`${this.urlRaiz}/api/grupo-pv/delete`, { GrupoPreguntaValoracionId: item.GrupoPreguntaValoracionId }, { headers: this.auth() })
      .then(()=> { this.toast('Grupo eliminado'); this.loadGrupos(); })
      .catch(()=> this.toast('No se pudo eliminar (¿tiene preguntas?)','error'));
  },


    // Preguntas
    loadPreguntas() {
      if (!this.grupoSel) { this.preguntas=[]; return; }
      this.loadingPreguntas = true;
      axios.get(`${this.urlRaiz}/api/pregunta-pv/list`, {
          params: { grupoId: this.grupoSel.GrupoPreguntaValoracionId, tipo: this.filtros.tipo },
          headers: this.auth()
        })
        .then(r => this.preguntas = r.data)
        .catch(()=> this.toast('Error cargando preguntas','error'))
        .finally(()=> this.loadingPreguntas=false);
    },
    openPreguntaDialog(item) {
      this.dlgPregunta.editing = !!item;
      this.dlgPregunta.data = item
        ? { ...item }
        : { Texto:'', TipoValoracion:this.filtros.tipo, Orden:(this.preguntas.length+1), Activa:true, GrupoPreguntaValoracionId: this.grupoSel?.GrupoPreguntaValoracionId };
      this.dlgPregunta.visible = true;
    },
    savePregunta() {
      if (!this.grupoSel) return;
      this.dlgPregunta.data.GrupoPreguntaValoracionId = this.grupoSel.GrupoPreguntaValoracionId;
      const url = this.dlgPregunta.editing ? '/api/pregunta-pv/update' : '/api/pregunta-pv/create';
      axios.post(this.urlRaiz + url, this.dlgPregunta.data, { headers: this.auth() })
        .then(()=>{ this.dlgPregunta.visible=false; this.loadPreguntas(); this.toast('Pregunta guardada'); })
        .catch(()=> this.toast('Error guardando pregunta','error'));
    },
    togglePregunta(item) {
      axios.post(`${this.urlRaiz}/api/pregunta-pv/toggle`, { PreguntaValoracionId: item.PreguntaValoracionId }, { headers: this.auth() })
        .then(()=> this.loadPreguntas())
        .catch(()=> this.toast('Error al cambiar estado','error'));
    },
    deletePregunta(item) {
      if (!confirm('¿Eliminar pregunta?')) return;
      axios.post(`${this.urlRaiz}/api/pregunta-pv/delete`, { PreguntaValoracionId: item.PreguntaValoracionId }, { headers: this.auth() })
        .then(()=> { this.toast('Pregunta eliminada'); this.loadPreguntas(); })
        .catch(()=> this.toast('No se pudo eliminar (¿tiene respuestas?)','error'));
    }
  }
};
</script>

